import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 14 14"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M7 0c1.467 0 2.765.119 3.555.301a4.08 4.08 0 0 1 3.144 3.144C13.88 4.235 14 5.533 14 7s-.119 2.765-.301 3.555a4.08 4.08 0 0 1-3.144 3.144C9.765 13.88 8.467 14 7 14s-2.765-.119-3.555-.301a4.08 4.08 0 0 1-3.144-3.144C.12 9.765 0 8.467 0 7s.119-2.765.301-3.555A4.08 4.08 0 0 1 3.445.301C4.235.12 5.533 0 7 0m.93 10.156c.343.072.625.31.758.628a.26.26 0 0 0 .264.159l.086-.008c.549-.055.98-.132 1.23-.221h.002a.45.45 0 0 0 .288-.418v-.014l-.001-.024v-.005l-.002-.015c-.042-.573-.39-1.915-.908-3.447-.593-1.752-1.213-3.17-1.492-3.446a.6.6 0 0 0-.237-.152l-.003-.001c-.184-.062-.522-.104-.91-.104-.387 0-.726.042-.91.104h-.002a.6.6 0 0 0-.237.152c-.28.277-.9 1.695-1.492 3.447-.519 1.532-.866 2.874-.909 3.447v.015l-.001.005-.002.024v.014c0 .19.12.354.288.417l.002.001c.25.09.682.166 1.232.22l.075.008c.118.01.23-.056.276-.165.134-.313.415-.55.755-.621.206-.048.544-.079.925-.079.382 0 .72.031.925.079",
      clipRule: "evenodd"
    }
  )
);
var SvgAircallIcon = styled(SvgComponent)`
  ${size}
  ${color}
`;
var AircallIcon_default = SvgAircallIcon;

export { AircallIcon_default as default };
